<div class="wrapper" [class.wrapper--calculator]="shell.insideApp()">
  <app-header></app-header>

  @if (appCheckErrorService.errorMessage(); as errorMessage) {
    <div class="frame">
      <div class="alert alert-danger" role="alert">
        {{ errorMessage }}
        <br />
        This issue has been reported to our team. We will investigate and fix it as soon as possible.
      </div>
    </div>
  }

  <div
    class="frame"
    [class.frame-margin]="shell.insideApp()"
  >
    @if (shell.insideApp()) {
      <div class="flex-container">
        <div
          class="content"
          [style.background-color]="ups.preferences()?.panelColor"
        >
          <app-stage-nav></app-stage-nav>
          <router-outlet (deactivate)="onDeactivate()"></router-outlet>
        </div>
      </div>
    } @else {
      <router-outlet (deactivate)="onDeactivate()"></router-outlet>
    }
  </div>

  @if (shell.showFooter()) {
    <app-disclaimer-footer></app-disclaimer-footer>
  }
</div>
